module.exports = __webpack_public_path__ + "img/352.48a7bd39.png";